<!-- cv简历信息表-基本信息-组件级 -->
<template>
  <div class='detail-wrap'>
    <div class='detail-container'>
      <div class='cv-detail cn'
           v-if='!isEditCn && lang==="cn"'>
        <ul>
          <li>
            <span class='cv-detail-name'>出生日期：</span>
            <span class='cv-detail-val'>{{baseInfoDetailCn.birthday}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>性别：</span>
            <span class='cv-detail-val'>{{baseInfoDetailCn.gender && new Map(sexCnMap).get(baseInfoDetailCn.gender)}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>国籍：</span>
            <span class='cv-detail-val'>{{baseInfoDetailCn.nationality}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>曾用名：</span>
            <span class='cv-detail-val'>{{baseInfoDetailCn.formerName}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>民族：</span>
            <span class='cv-detail-val'>{{baseInfoDetailCn.nation}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>出生地（和护照一致）：</span>
            <span class='cv-detail-val'>{{baseInfoDetailCn.birthplace}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>婚姻状态：</span>
            <span class='cv-detail-val'>{{baseInfoDetailCn.maritalStatus && new Map(maritalCnMap).get(baseInfoDetailCn.maritalStatus)}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>母语（在家使用语言）：</span>
            <span class='cv-detail-val'>{{baseInfoDetailCn.firstLanguage}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>手机号：</span>
            <span class='cv-detail-val'>{{baseInfoDetailCn.phone}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>固定电话：</span>
            <span class='cv-detail-val'>{{baseInfoDetailCn.telephone}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>紧急联系电话：</span>
            <span class='cv-detail-val'>{{baseInfoDetailCn.emergencyPhone}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>家庭住址：</span>
            <span class='cv-detail-val'>{{baseInfoDetailCn.homeAddress}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>邮编：</span>
            <span class='cv-detail-val'>{{baseInfoDetailCn.zipCode}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>邮寄地址：</span>
            <span class='cv-detail-val'>{{baseInfoDetailCn.mailingAddress}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>邮编：</span>
            <span class='cv-detail-val'>{{baseInfoDetailCn.mailingZipCode}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>计划申请专业：</span>
            <span class='cv-detail-val'>{{baseInfoDetailCn.targetApplyMajor}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>计划取得最高学位：</span>
            <span class='cv-detail-val'>{{baseInfoDetailCn.targetHighestDegree && new Map(highestDegreeCnMap).get(baseInfoDetailCn.targetHighestDegree)}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>未来职业兴趣：</span>
            <span class='cv-detail-val'>{{baseInfoDetailCn.vocationalInterest}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>护照号码：</span>
            <span class='cv-detail-val'>{{baseInfoDetailCn.passportNumber}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>是否有美国签证或绿卡：</span>
            <span class='cv-detail-val'>{{baseInfoDetailCn.hasUsVisa && new Map(hasUsVisaCnMap).get(baseInfoDetailCn.hasUsVisa)}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>签证类型：</span>
            <span class='cv-detail-val'>{{baseInfoDetailCn.visaType}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>签证号码：</span>
            <span class='cv-detail-val'>{{baseInfoDetailCn.visaNumber}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>签证有效期：</span>
            <span class='cv-detail-val'>{{baseInfoDetailCn.visaStartTime && baseInfoDetailCn.visaEndTime && `${baseInfoDetailCn.visaStartTime} 至 ${baseInfoDetailCn.visaEndTime}`}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>签证号码：</span>
            <span class='cv-detail-val'>{{baseInfoDetailCn.sevisNumber}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>选择资料：</span>
            <span class='cv-detail-val'>
              <a v-if='baseInfoDetailCn.fileUrl'
                 href='javascript:void(0)'
                 @click="handleDownload(baseInfoDetailCn)">{{baseInfoDetailCn.originFilename}}</a>
            </span>
          </li>
        </ul>
      </div>
      <div class='cv-detail en'
           v-if='!isEditEn && lang==="en"'>
        <ul>
          <li>
            <span class='cv-detail-name'>Date of birth：</span>
            <span class='cv-detail-val'>{{baseInfoDetailEn.birthday}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Gender：</span>
            <span class='cv-detail-val'>{{baseInfoDetailEn.gender && new Map(sexEnMap).get(baseInfoDetailEn.gender)}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Nationality：</span>
            <span class='cv-detail-val'>{{baseInfoDetailEn.nationality}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Former Name：</span>
            <span class='cv-detail-val'>{{baseInfoDetailEn.formerName}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Nation：</span>
            <span class='cv-detail-val'>{{baseInfoDetailEn.nation}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Place of birth：</span>
            <span class='cv-detail-val'>{{baseInfoDetailEn.birthplace}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Marital Status：</span>
            <span class='cv-detail-val'>{{baseInfoDetailEn.maritalStatus && new Map(maritalEnMap).get(baseInfoDetailEn.maritalStatus)}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Native Language：</span>
            <span class='cv-detail-val'>{{baseInfoDetailEn.firstLanguage}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Cell Phone Number：</span>
            <span class='cv-detail-val'>{{baseInfoDetailEn.phone}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Telephone Number：</span>
            <span class='cv-detail-val'>{{baseInfoDetailEn.telephone}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Emergency Contact：</span>
            <span class='cv-detail-val'>{{baseInfoDetailEn.emergencyPhone}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Home Address：</span>
            <span class='cv-detail-val'>{{baseInfoDetailEn.homeAddress}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Zip Code：</span>
            <span class='cv-detail-val'>{{baseInfoDetailEn.zipCode}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Mailing Address：</span>
            <span class='cv-detail-val'>{{baseInfoDetailEn.mailingAddress}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Zip Code：</span>
            <span class='cv-detail-val'>{{baseInfoDetailEn.mailingZipCode}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Prospective Majors：</span>
            <span class='cv-detail-val'>{{baseInfoDetailEn.targetApplyMajor}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Highest Degree Planning to Attain：</span>
            <span class='cv-detail-val'>{{baseInfoDetailEn.targetHighestDegree && new Map(highestDegreeEnMap).get(baseInfoDetailEn.targetHighestDegree)}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Prospective Careers：</span>
            <span class='cv-detail-val'>{{baseInfoDetailEn.vocationalInterest}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Passport ID：</span>
            <span class='cv-detail-val'>{{baseInfoDetailEn.passportNumber}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Whether the applicant currently holds American visa or green card：</span>
            <span class='cv-detail-val'>{{baseInfoDetailEn.hasUsVisa && new Map(hasUsVisaEnMap).get(baseInfoDetailEn.hasUsVisa)}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Visa Type：</span>
            <span class='cv-detail-val'>{{baseInfoDetailEn.visaType}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Visa Number：</span>
            <span class='cv-detail-val'>{{baseInfoDetailEn.visaNumber}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Visa expiration date：</span>
            <span class='cv-detail-val'>{{baseInfoDetailEn.visaStartTime && baseInfoDetailEn.visaEndTime && `${baseInfoDetailEn.visaStartTime} to ${baseInfoDetailEn.visaEndTime}`}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>SEVIS ID Number：</span>
            <span class='cv-detail-val'>{{baseInfoDetailEn.sevisNumber}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Select Document：</span>
            <span class='cv-detail-val'>
              <a v-if='baseInfoDetailEn.fileUrl'
                 @click="handleDownload(baseInfoDetailEn)">{{baseInfoDetailEn.originFilename}}</a>
            </span>
          </li>
        </ul>
      </div>
      <div class='cv-form cn'
           v-if='isEditCn && lang==="cn"'>
        <Form ref="formValidateCn"
              :model="formValidateCn"
              :rules="ruleValidateCn"
              :label-width="300">

          <div class="base-form-item">
            <FormItem label="出生日期："
                      prop="birthday">
              <date-picker-wrapper type="date"
                                   :editable="false"
                                   placeholder="请选择出生日期"
                                   v-model="formValidateCn.birthday"
                                   style="width:100%;"></date-picker-wrapper>
            </FormItem>
            <FormItem label="性别："
                      prop="gender">
              <Select v-model="formValidateCn.gender"
                      placeholder="请选择"
                      clearable>
                <Option v-for="(item, index) in sexCnMap"
                        :value="item[0]"
                        :key="index">{{item[1] }}
                </Option>
              </Select>
            </FormItem>
            <FormItem label="国籍："
                      prop="nationality">
              <Input v-model="formValidateCn.nationality"
                     placeholder="请输入国籍"
                     clearable></Input>
            </FormItem>
            <FormItem label="曾用名："
                      prop="formerName">
              <Input v-model="formValidateCn.formerName"
                     placeholder="请输入曾用名"
                     clearable></Input>
            </FormItem>
            <FormItem label="民族："
                      prop="nation">
              <Input v-model="formValidateCn.nation"
                     placeholder="请输入民族"
                     clearable></Input>
            </FormItem>
            <FormItem label="出生地："
                      prop="birth">
              <Input v-model="formValidateCn.birthplace"
                     placeholder="请写明城市，省份，国家"
                     clearable></Input>
            </FormItem>
            <FormItem label="婚姻状态："
                      prop="marital">
              <Select v-model="formValidateCn.maritalStatus"
                      placeholder="请选择"
                      clearable>
                <Option v-for="item in maritalCnMap"
                        :value="item[0]"
                        :key="item[0]">{{item[1] }}
                </Option>
              </Select>
            </FormItem>
            <FormItem label="母语："
                      prop="firstLanguage">
              <Input v-model="formValidateCn.firstLanguage"
                     placeholder="请输入母语"
                     clearable></Input>
            </FormItem>
            <FormItem label="手机号："
                      prop="phone">
              <Input v-model="formValidateCn.phone"
                     placeholder="请输入手机号"
                     clearable></Input>
            </FormItem>
            <FormItem label="固定电话："
                      prop="telephone">
              <Input v-model="formValidateCn.telephone"
                     placeholder="请输入固定电话"
                     clearable></Input>
            </FormItem>
            <FormItem label="紧急联系电话："
                      prop="emergencyPhone">
              <Input v-model="formValidateCn.emergencyPhone"
                     placeholder="请输入紧急联系电话"
                     clearable></Input>
            </FormItem>
            <FormItem label="家庭住址："
                      prop="homeAddress">
              <Input type='textarea'
                     :rows='5'
                     v-model="formValidateCn.homeAddress"
                     placeholder="请输入家庭住址"
                     clearable></Input>
            </FormItem>
            <FormItem label="邮编：">
              <Input v-model="formValidateCn.zipCode"
                     placeholder="请输入家庭住址邮编"
                     clearable></Input>
            </FormItem>
            <FormItem label="邮寄地址："
                      prop="mailingAddress">
              <Input type='textarea'
                     :rows='5'
                     v-model="formValidateCn.mailingAddress"
                     placeholder="请输入邮寄地址"></Input>
            </FormItem>
            <FormItem label="邮编："
                      prop="mailingZipCode">
              <Input v-model="formValidateCn.mailingZipCode"
                     placeholder="请输入邮寄地址邮编"
                     clearable></Input>
            </FormItem>
            <FormItem label="计划申请专业："
                      prop="targetApplyMajor">
              <Input v-model="formValidateCn.targetApplyMajor"
                     placeholder="请输入计划申请专业"
                     clearable></Input>
            </FormItem>
            <FormItem label="计划取得的最高学位："
                      prop="targetHighestDegree">
              <Select v-model="formValidateCn.targetHighestDegree"
                      placeholder="请选择">
                <Option v-for="item in highestDegreeCnMap"
                        :value="item[0]"
                        :key="item[0]"
                        clearable>{{item[1]}}
                </Option>
              </Select>
            </FormItem>
            <FormItem label="未来职业兴趣："
                      prop="vocationalInterest">
              <Input v-model="formValidateCn.vocationalInterest"
                     placeholder="请输入未来职业兴趣"
                     clearable></Input>
            </FormItem>
            <FormItem label="护照号码："
                      prop="passportNumber">
              <Input v-model="formValidateCn.passportNumber"
                     placeholder="请输入护照号码"
                     clearable></Input>
            </FormItem>
            <FormItem label="是否有美国签证或绿卡："
                      prop="hasUsVisa">
              <Select v-model="formValidateCn.hasUsVisa"
                      placeholder="请选择"
                      clearable>
                <Option v-for="(item, index) in hasUsVisaCnMap"
                        :value="item[0]"
                        :key="index">{{item[1]}}
                </Option>
              </Select>
            </FormItem>
            <FormItem label="签证类型："
                      prop="visaType">
              <Input v-model="formValidateCn.visaType"
                     placeholder="请输入签证类型"
                     clearable></Input>
            </FormItem>
            <FormItem label="签证号码："
                      prop="visaNumber">
              <Input v-model="formValidateCn.visaNumber"
                     placeholder="请输入签证号码"></Input>
            </FormItem>
            <FormItem label="签证有效期："
                      prop="visaStartTime">
              <date-picker-wrapper type="daterange"
                                   :editable='false'
                                   placeholder="请选择"
                                   v-model="formValidateCn.visaTime"
                                   style="width:100%;"></date-picker-wrapper>
            </FormItem>
            <FormItem label="SEVIS号码："
                      prop="sevisNumber">
              <Input v-model="formValidateCn.sevisNumber"
                     placeholder="请输入SEVIS号码"
                     clearable></Input>
            </FormItem>
            <div class='cv-file-upload-wrap'>
              <div class='cv-file-name'>选择材料：</div>
              <div class='cv-file-upload'>
                <upload-wrapper product-line="UNDERGRADUATE"
                                :format="['zip','rar']"
                                :size='10'
                                @on-success="onSuccessCn"
                                @on-before-upload='handleBeforeUploadCn'
                                @on-type-error="uploadTypeErrorCn"
                                @on-size-error='uploadSizeErrorCn(10)'
                                @on-name-error="uploadNameErrorCn"
                                v-model="formValidateCn.fileParams"
                                :path="`cv/info/${new Date().getTime()}`">
                  <div class="cv-file-upload-prompt">
                    附上I-20和I-94表格扫描件或清晰数码照片，请上传zip或rar压缩包
                  </div>
                </upload-wrapper>
                <div style="text-align: left; line-height: 20px"
                     v-if="filenameShowCn">{{ formValidateCn.fileParams.originFilename }}</div>
                <div style="text-align: left; line-height: 20px; color: red"
                     v-if="uploadError.cn">{{ uploadError.cn.typeErrorMessage || uploadError.cn.sizeErrorMessage || uploadError.cn.nameErrorMessage }}</div>
              </div>
            </div>
          </div>
          <div class="sub-btn">
            <Button type='primary'
                    :loading='hasSaveCn'
                    @click="saveCn">保存
            </Button>
            <!-- <a href='javascript: void(0)'
               @click="saveCn">保存</a> -->
          </div>
        </Form>
      </div>
      <div class='cv-form en'
           v-if='isEditEn && lang==="en"'>
        <Form ref="formValidateEn"
              :model="formValidateEn"
              :rules="ruleValidateEn"
              :label-width="300">

          <div class="base-form-item">
            <FormItem label="Date of birth："
                      prop="birthday">
              <date-picker-wrapper type="date"
                                   :editable='false'
                                   placeholder="please select"
                                   v-model="formValidateEn.birthday"
                                   style="width:100%;"></date-picker-wrapper>
            </FormItem>
            <FormItem label="Gender："
                      prop="gender">
              <Select v-model="formValidateEn.gender"
                      placeholder="please select"
                      clearable>
                <Option v-for="(item, index) in sexEnMap"
                        :value="item[0]"
                        :key="index">{{item[1]}}
                </Option>
              </Select>
            </FormItem>
            <FormItem label="Nationality："
                      prop="nationality">
              <Input v-model="formValidateEn.nationality"
                     placeholder="please enter nationality"
                     clearable></Input>
            </FormItem>
            <FormItem label="Former Name："
                      prop="formerName">
              <Input v-model="formValidateEn.formerName"
                     placeholder="please enter former name"
                     clearable></Input>
            </FormItem>
            <FormItem label="Nation："
                      prop="nation">
              <Input v-model="formValidateEn.nation"
                     placeholder="please enter nation"
                     clearable></Input>
            </FormItem>
            <FormItem label="Place of birth："
                      prop="birth">
              <Input v-model="formValidateEn.birthplace"
                     placeholder="please specify city, province, and country"
                     clearable></Input>
            </FormItem>
            <FormItem label="Marital Status："
                      prop="marital">
              <Select v-model="formValidateEn.maritalStatus"
                      placeholder="please select"
                      clearable>
                <Option v-for="(item, index) in maritalEnMap"
                        :value="item[0]"
                        :key="index">{{item[1]}}
                </Option>
              </Select>
            </FormItem>
            <FormItem label="Native Language："
                      prop="firstLanguage">
              <Input v-model="formValidateEn.firstLanguage"
                     placeholder="please enter native language"
                     clearable></Input>
            </FormItem>
            <FormItem label="Cell Phone Number："
                      prop="phone">
              <Input v-model="formValidateEn.phone"
                     placeholder="please enter cell phone number"
                     clearable></Input>
            </FormItem>
            <FormItem label="Telephone Number："
                      prop="telephone">
              <Input v-model="formValidateEn.telephone"
                     placeholder="please enter telephone number"
                     clearable></Input>
            </FormItem>
            <FormItem label="Emergency Contact："
                      prop="emergencyPhone">
              <Input v-model="formValidateEn.emergencyPhone"
                     placeholder="please enter emergency contact"
                     clearable></Input>
            </FormItem>
            <FormItem label="Home Address："
                      prop="homeAddress">
              <Input type='textarea'
                     :rows='5'
                     v-model="formValidateEn.homeAddress"
                     placeholder="please enter home address"
                     clearable></Input>
            </FormItem>
            <FormItem label="Zip Code：">
              <Input v-model="formValidateEn.zipCode"
                     placeholder="please enter the zip code of your home address"
                     clearable></Input>
            </FormItem>
            <FormItem label="Mailing Address："
                      prop="mailingAddress">
              <Input type='textarea'
                     :rows='5'
                     v-model="formValidateEn.mailingAddress"
                     placeholder="please enter your preferred mailing address of various materials"
                     clearable></Input>
            </FormItem>
            <FormItem label="Zip Code："
                      prop="mailingZipCode">
              <Input v-model="formValidateEn.mailingZipCode"
                     placeholder="please enter the zip code of your mailing address"
                     clearable></Input>
            </FormItem>
            <FormItem label="Prospective Majors："
                      prop="targetApplyMajor">
              <Input v-model="formValidateEn.targetApplyMajor"
                     placeholder="please enter the major you plan to apply for"
                     clearable></Input>
            </FormItem>
            <FormItem label="Highest Degree Planning to Attain："
                      prop="targetHighestDegree">
              <Select v-model="formValidateEn.targetHighestDegree"
                      placeholder="please select"
                      clearable>
                <Option v-for="(item, index) in highestDegreeEnMap"
                        :value="item[0]"
                        :key="index">{{item[1]}}
                </Option>
              </Select>
            </FormItem>
            <FormItem label="Prospective Careers："
                      prop="vocationalInterest">
              <Input v-model="formValidateEn.vocationalInterest"
                     placeholder="please enter your prospective careers"
                     clearable></Input>
            </FormItem>
            <FormItem label="Passport ID："
                      prop="passportNumber">
              <Input v-model="formValidateEn.passportNumber"
                     placeholder="please enter passport ID"
                     clearable></Input>
            </FormItem>
            <FormItem label="Whether the applicant currently holds American visa or green card："
                      prop="hasUsVisa">
              <Select v-model="formValidateEn.hasUsVisa"
                      placeholder="please select"
                      clearable>
                <Option v-for="(item, index) in hasUsVisaEnMap"
                        :value="item[0]"
                        :key="index">{{item[1]}}
                </Option>
              </Select>
            </FormItem>
            <FormItem label="Visa Type："
                      prop="visaType">
              <Input v-model="formValidateEn.visaType"
                     placeholder="please enter visa type"
                     clearable></Input>
            </FormItem>
            <FormItem label="Visa Number："
                      prop="visaNumber">
              <Input v-model="formValidateEn.visaNumber"
                     placeholder="please enter visa number"
                     clearable></Input>
            </FormItem>
            <FormItem label="Visa expiration date："
                      prop="visaNumber">
              <date-picker-wrapper type="daterange"
                                   :editable='false'
                                   placeholder="please select"
                                   v-model="formValidateEn.visaTime"
                                   style="width:100%;"></date-picker-wrapper>
            </FormItem>
            <FormItem label="SEVIS ID Number："
                      prop="sevisNumber">
              <Input v-model="formValidateEn.sevisNumber"
                     placeholder="please enter SEVIS ID number"
                     clearable></Input>
            </FormItem>
            <div class='cv-file-upload-wrap'>
              <div class='cv-file-name'>Select Document：</div>
              <div class='cv-file-upload'>
                <upload-wrapper product-line="UNDERGRADUATE"
                                :format="['zip','rar']"
                                :size='10'
                                @on-success="onSuccessEn"
                                @on-type-error="uploadTypeErrorEn"
                                @on-size-error='uploadSizeErrorEn(10)'
                                @on-name-error="uploadNameErrorEn"
                                @on-before-upload='handleBeforeUploadEn'
                                v-model="formValidateEn.fileParams"
                                :path="`cv/info/${new Date().getTime()}`">
                  <div class="cv-file-upload-prompt">
                    Please attach a scanned copy of I-20 and I-94 in zip. or rar. form
                  </div>
                </upload-wrapper>
                <div style="text-align: left; line-height: 20px"
                     v-if="filenameShowEn">{{ formValidateEn.fileParams.originFilename }}</div>
                <div style="text-align: left; line-height: 20px; color: red"
                     v-if="uploadError.en">{{ uploadError.en.typeErrorMessage || uploadError.en.sizeErrorMessage || uploadError.en.nameErrorMessage }}</div>
              </div>
            </div>
          </div>
          <div class="sub-btn">
            <Button type='primary'
                    :loading='hasSaveEn'
                    @click="saveEn">Save
            </Button>
            <!-- <a href='javascript: void(0)'
               @click="saveEn">Save</a> -->
          </div>
        </Form>
      </div>
      <div class='cv-btn cn'
           v-if='lang==="cn"'>
        <a href='javascript: void(0)'
           @click="goEdit('CN')">{{isEditCn ? '返回' : '编辑'}}</a>
      </div>
      <div class='cv-btn en'
           v-if='lang==="en"'>
        <a href='javascript: void(0)'
           @click="goEdit('EN')">{{isEditEn ? 'back' : 'Edit'}}</a>
      </div>
    </div>
  </div>
</template>

<script>

import {
  hasUsVisaCnMap,
  hasUsVisaEnMap,
  highestDegreeCnMap,
  highestDegreeEnMap,
  maritalCnMap,
  maritalEnMap,
  sexCnMap,
  sexEnMap
} from '../constants'
import './cv-detail.less'
import dayjs from 'dayjs'
import cvService from '@/api/undergraduate/cv'
import { downFile, ossSecretLinkUgd } from '@/api/oss'
import DatePickerWrapper from '@/components/date/DatePickerWrapper'
import UploadWrapper from '@/components/upload/upload-wrapper'

export default {
  name: '',
  props: {
    lang: {
      type: String,
      default: ''
    }
  },
  components: { UploadWrapper, DatePickerWrapper },
  data () {
    return {
      filenameShowCn: false,
      filenameShowEn: false,
      // 性别映射
      sexCnMap,
      sexEnMap,
      // 婚姻状况映射
      maritalCnMap,
      maritalEnMap,
      // 是否有美国签证或绿卡映射
      hasUsVisaCnMap,
      hasUsVisaEnMap,
      highestDegreeCnMap,
      highestDegreeEnMap,
      // 基本信息详情
      baseInfoDetailCn: {
        birthday: '',
        gender: '',
        nationality: '',
        formerName: '',
        nation: '',
        birthplace: '',
        maritalStatus: '',
        firstLanguage: '',
        phone: '',
        telephone: '',
        emergencyPhone: '',
        homeAddress: '',
        zipCode: '',
        mailingAddress: '',
        mailingZipcode: '',
        targetApplyMajor: '',
        targetHighestDegree: '',
        vocationalInterest: '',
        passportNumber: '',
        hasUsVisa: '',
        visaType: '',
        visaNumber: '',
        visaStartTime: '',
        visaEndTime: '',
        sevisNumber: '',
        fileUrl: '',
        originFilename: ''
      },
      baseInfoDetailEn: {
        birthday: '',
        gender: '',
        nationality: '',
        formerName: '',
        nation: '',
        birthplace: '',
        maritalStatus: '',
        firstLanguage: '',
        phone: '',
        telephone: '',
        emergencyPhone: '',
        homeAddress: '',
        zipCode: '',
        mailingAddress: '',
        mailingZipcode: '',
        targetApplyMajor: '',
        targetHighestDegree: '',
        vocationalInterest: '',
        passportNumber: '',
        hasUsVisa: '',
        visaType: '',
        visaNumber: '',
        visaStartTime: '',
        visaEndTime: '',
        sevisNumber: '',
        fileUrl: '',
        originFilename: ''
      },
      // 是否编辑状态标识
      isEditEn: false,
      isEditCn: false,
      // Cn表单
      formValidateCn: {
        birthday: '',
        num: 1,
        gender: '',
        nationality: '',
        formerName: '',
        nation: '',
        maritalStatus: '',
        firstLanguage: '',
        phone: '',
        telephone: '',
        emergencyPhone: '',
        homeAddress: '',
        zipCode: '',
        mailingAddress: '',
        mailingZipCode: '',
        targetApplyMajor: '',
        targetHighestDegree: '',
        vocationalInterest: '',
        passportNumber: '',
        visaTime: [],
        sevisNumber: '',
        hasUsVisa: '',
        fileUrl: '',
        originFilename: '',
        fileParams: {}
      },
      ruleValidateCn: {},
      // En表单
      formValidateEn: {
        birthday: '',
        gender: '',
        nationality: '',
        formerName: '',
        nation: '',
        maritalStatus: '',
        firstLanguage: '',
        phone: '',
        telephone: '',
        emergencyPhone: '',
        homeAddress: '',
        zipCode: '',
        mailingAddress: '',
        mailingZipCode: '',
        targetApplyMajor: '',
        targetHighestDegree: '',
        vocationalInterest: '',
        passportNumber: '',
        visaTime: [],
        sevisNumber: '',
        hasUsVisa: '',
        fileUrl: '',
        originFilename: '',
        fileParams: {}
      },
      ruleValidateEn: {},
      // loading-表单提交-避免重复提交
      hasSaveCn: false,
      hasSaveEn: false,
      uploadError: {
        cn: {
          typeErrorMessage: '',
          sizeErrorMessage: '',
          nameErrorMessage: ''
        },
        en: {
          typeErrorMessage: '',
          sizeErrorMessage: '',
          nameErrorMessage: ''
        }
      }
    }
  },
  computed: {},
  mounted () {
    this.$nextTick(() => {
      if (this.lang === 'cn') {
        this.getBaseInfoDetailCn()
      }
      if (this.lang === 'en') {
        this.getBaseInfoDetailEn()
      }
    })
  },
  methods: {
    // 获取基本信息-cn
    getBaseInfoDetailCn () {
      cvService.cvBaseInfoDetailCn().then(res => {
        if (res.data.model) {
          this.baseInfoDetailCn = res.data.model
          this.baseInfoDetailCn.hasUsVisa = (String(this.baseInfoDetailCn.hasUsVisa) === 'false' || this.baseInfoDetailCn.hasUsVisa) ? String(this.baseInfoDetailCn.hasUsVisa) : ''
          this.baseInfoDetailCn.gender = (this.baseInfoDetailCn.gender === 0 || this.baseInfoDetailCn.gender) ? String(this.baseInfoDetailCn.gender) : ''
        }
      }).catch(error => {
        this.$ugd_message(error.message, 'error')
      })
    },
    // 获取基本信息-en
    getBaseInfoDetailEn () {
      cvService.cvBaseInfoDetailEn().then(res => {
        if (res.data.model) {
          this.baseInfoDetailEn = res.data.model

          this.baseInfoDetailEn.hasUsVisa = (String(this.baseInfoDetailEn.hasUsVisa) === 'false' || this.baseInfoDetailEn.hasUsVisa) ? String(this.baseInfoDetailEn.hasUsVisa) : ''

          this.baseInfoDetailEn.gender = (this.baseInfoDetailEn.gender === 0 || this.baseInfoDetailEn.gender) ? String(this.baseInfoDetailEn.gender) : ''
        }
      }).catch(error => {
        this.$ugd_message(error.message, 'error')
      })
    },
    // 编辑-返回
    goEdit (type) {
      let map = { CN: 'Cn', EN: 'En' }
      let l = map[type]
      cvService[`cvBaseInfoDetail${l}`]().then(res => {
        let model = res.data.model
        if (model) {
          if (this[`isEdit${l}`]) {
            this[`baseInfoDetail${l}`] = model
            this[`baseInfoDetail${l}`].hasUsVisa = (String(model.hasUsVisa) === 'false' || model.hasUsVisa) ? String(model.hasUsVisa) : ''
            this[`baseInfoDetail${l}`].gender = (model.gender === 0 || model.gender) ? model.gender + '' : ''
            this[`baseInfoDetail${l}`].visaTime = [model.visaStartTime, model.visaEndTime]
          } else {
            this[`formValidate${l}`] = model
            this[`formValidate${l}`].hasUsVisa = (String(model.hasUsVisa) === 'false' || model.hasUsVisa) ? String(model.hasUsVisa) : ''
            this[`formValidate${l}`].gender = (model.gender === 0 || model.gender) ? model.gender + '' : ''
            this[`formValidate${l}`].visaTime = [model.visaStartTime, model.visaEndTime]
            this[`formValidate${l}`].fileParams = { url: model.fileUrl, originFilename: model.originFilename }
            if (this[`formValidate${l}`].fileParams && this[`formValidate${l}`].fileParams.originFilename) {
              this[`filenameShow${l}`] = true
            }
          }
        }
        this[`isEdit${l}`] = !this[`isEdit${l}`]
        this.uploadError.cn.typeErrorMessage = ''
        this.uploadError.cn.sizeErrorMessage = ''
        this.uploadError.cn.nameErrorMessage = ''
        this.uploadError.en.typeErrorMessage = ''
        this.uploadError.en.sizeErrorMessage = ''
        this.uploadError.en.nameErrorMessage = ''
      })
    },
    // 下载
    handleDownload ({ fileUrl, originFilename }) {
      ossSecretLinkUgd({
        dir: fileUrl
      }).then(res => {
        window.open(res.data.url)
        // this.downFile(res.data.url, originFilename)
      })
    },
    // 下载二进制文件
    downFile (url, filename) {
      downFile({
        filename,
        url
      })
    },
    handleBeforeUploadCn () {
      this.filenameShowCn = false
      this.uploadError.cn.typeErrorMessage = ''
      this.uploadError.cn.sizeErrorMessage = ''
      this.uploadError.cn.nameErrorMessage = ''
    },
    uploadTypeErrorCn () {
      this.uploadError.cn.typeErrorMessage = '请上传zip或rar压缩包'
    },
    uploadSizeErrorCn (size) {
      this.uploadError.cn.sizeErrorMessage = `上传文件大小不能大于${size}MB`
    },
    uploadNameErrorCn () {
      this.uploadError.cn.nameErrorMessage = '上传文件名不能包含特殊符号'
    },
    handleBeforeUploadEn () {
      this.filenameShowEn = false
      this.uploadError.en.typeErrorMessage = ''
      this.uploadError.en.sizeErrorMessage = ''
      this.uploadError.en.nameErrorMessage = ''
    },
    uploadTypeErrorEn () {
      this.uploadError.en.typeErrorMessage = 'Please attach a scanned copy of I-20 and I-94 in zip. or rar. form'
    },
    uploadSizeErrorEn (size) {
      this.uploadError.en.sizeErrorMessage = `Upload file size should not be greater than ${size}MB`
    },
    uploadNameErrorEn () {
      this.uploadError.en.nameErrorMessage = 'Uploaded file name cannot contain special symbols'
    },
    // 保存
    saveCn () {
      this.hasSaveCn = true
      if (this.formValidateCn.visaTime[0]) {
        this.formValidateCn.visaStartTime = dayjs(this.formValidateCn.visaTime[0]).format('YYYY-MM-DD')
      }
      if (this.formValidateCn.visaTime[1]) {
        this.formValidateCn.visaEndTime = dayjs(this.formValidateCn.visaTime[1]).format('YYYY-MM-DD')
      }
      this.formValidateCn.originFilename = this.formValidateCn.fileParams.originFilename
      this.formValidateCn.fileUrl = this.formValidateCn.fileParams.url
      this.formValidateCn.fileParams = {}
      cvService.cvSaveBaseInfoCn(this.formValidateCn).then(res => {
        this.hasSaveCn = false
        this.$ugd_message('保存成功', 'success')
        this.goEdit('CN')
      }).catch(error => {
        this.$ugd_message(error.message, 'error')
        this.hasSaveCn = false
      })
    },
    onSuccessCn (result) {
      this.formValidateCn.fileParams = result
      this.filenameShowCn = true
    },
    onSuccessEn (result) {
      this.formValidateEn.fileParams = result
      this.filenameShowEn = true
    },
    // Save
    saveEn () {
      this.hasSaveEn = true
      if (this.formValidateEn.visaTime[0]) {
        this.formValidateEn.visaStartTime = dayjs(this.formValidateEn.visaTime[0]).format('YYYY-MM-DD')
      }
      if (this.formValidateEn.visaTime[1]) {
        this.formValidateEn.visaEndTime = dayjs(this.formValidateEn.visaTime[1]).format('YYYY-MM-DD')
      }
      this.formValidateEn.originFilename = this.formValidateEn.fileParams.originFilename
      this.formValidateEn.fileUrl = this.formValidateEn.fileParams.url
      this.formValidateEn.fileParams = {}
      cvService.cvSaveBaseInfoEn(this.formValidateEn).then(res => {
        this.hasSaveEn = false
        this.$ugd_message('Save Success', 'success')
        this.goEdit('EN')
      }).catch(error => {
        this.hasSaveEn = false
        this.$ugd_message(error.message, 'error')
      })
    }
  }
}
</script>
<style lang='less' scoped>
.cv-file-upload-wrap {
  display: flex;
  font-size: 14px;
  color: #667483;
  .cv-file-name {
    flex: 0 0 300px;
    text-align: right;
    padding-right: 12px;
  }
  .cv-file-upload {
    flex: 1;
    border-radius: 8px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    margin-bottom: 40px;
    cursor: pointer;
    .cv-file-upload-prompt {
      display: inline-block;
    }
  }
}
</style>
